import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, exhaustMap, map } from 'rxjs/operators';
import { Dashboard } from '../../../models/dashboard.model';
import { ProfileImage } from '../../../models/profile-image.model';
import { HomeService } from '../../../services/home/home.service';
import { ProfileService } from '../../../services/profile/profile.service';
import * as fromAccountsActions from '../../actions/accounts/accounts.actions';
import * as fromCardsActions from '../../actions/cards/cards.actions';
import * as fromDashboardActions from '../../actions/dashboard/dashboard.actions';

@Injectable()
export class RootEffects {
  constructor(
    private actions$: Actions,
    private homeService: HomeService,
    private profileService: ProfileService,
    private router: Router,
    private domSanitizer: DomSanitizer
  ) {}

  getDashboardData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        fromDashboardActions.loadDashboardApi,
        fromDashboardActions.refreshDashboardApi
      ),
      exhaustMap(() => {
        return this.homeService.getData().pipe(
          map((dashboard: HttpResponse<Dashboard>) => {
            const dashboardProp: any = {
              ...dashboard.body,
              accounts: dashboard.body?.accounts
                ? dashboard.body?.accounts.map(item => {
                    return {
                      ...item,
                      activeBalance: item.balances[0]
                    };
                  })
                : null
            };
            if (document.location.href.includes('select-profile')) {
              this.router.navigate(['home']);
            }
            return dashboardProp;
          }),

          concatMap((dashboard: Dashboard) => {
            return [
              fromDashboardActions.loadDashboardDataSuccess({
                dashboard
              }),
              fromAccountsActions.layoutSelectActiveAccount({
                selectedAccount: dashboard.accounts
                  ? dashboard.accounts[0]
                  : null
              }),
              fromAccountsActions.layoutSelectActiveLoan({
                selectedLoan: dashboard.loans
                  ? dashboard.loans[0]
                  : null
              }),
              fromAccountsActions.layoutSelectActiveSaving({
                selectedSaving: dashboard.savings
                  ? dashboard.savings[0]
                  : null
              }),
              fromAccountsActions.layoutSelectActiveDeposit({
                selectedDeposit: dashboard.deposits
                  ? dashboard.deposits[0]
                  : null
              }),
              fromCardsActions.layoutSelectActiveCard({
                selectedCard: dashboard.cards ? dashboard.cards[0] : null
              })
            ];
          })
        );
      })
    )
  );

  getProfileImage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromDashboardActions.loadProfileImageApi),
      exhaustMap(() => {
        return this.profileService.getData().pipe(
          map((profileImg: HttpResponse<ProfileImage>) => {
            return fromDashboardActions.loadProfileImageSuccess({
              profileImg: profileImg.body?.data
                ? this.domSanitizer.bypassSecurityTrustUrl(
                    'data:image/jpg;base64,' + profileImg.body?.data
                  )
                : null
            });
          })
        );
      })
    )
  );
}
